<template>
  <div v-if="this.selectedQuestion" style="padding:1rem;">
    <div class="columns">
      <div class="column b-portlet">
        <div class="b-portlet-header">
          <div class="columns">
            <div class="column">
              <div class="content">
                <h3 class="is-marginless">
                  {{ this.process.name }} ({{ this.selectedQuestion.no }}/{{ this.questionCount }})
                  <button ref="focusButton" style="margin-left:-1500px;"></button>
                </h3>
              </div>
            </div>
            <div class="column is-2">
              <b-field class="is-pulled-right" grouped>
                <b-tooltip
                  class="control"
                  :label="$t('button.keep') + ' ' + $t('button.continueLater')"
                  position="is-bottom"
                  multilined
                >
                  <button class="button is-light" @click="saveAndContinueLater">
                    {{ $t('button.keep') }}
                  </button>
                </b-tooltip>
                <b-tooltip
                  class="control"
                  :label="$t('button.finishSurvey') + ' ' + $t('button.calculateOnlineAuditScore')"
                  position="is-bottom"
                  multilined
                >
                  <button class="button is-success" @click="finish">
                    {{ $t('button.finishSurvey') }}
                  </button>
                </b-tooltip>
              </b-field>
            </div>
          </div>
        </div>
        <div class="b-portlet-body">
          <div class="content">
            <div class="box">
              <div class="media-content">
                <div class="content">
                  <h5>{{ this.selectedQuestion.name }}</h5>
                  <div class="description-content" v-if="this.selectedQuestion.description">
                    <table>
                      <tr>
                        <td style="border:none !important; width:10px; padding-right:4px !important;">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            x="0px"
                            y="0px"
                            width="20"
                            height="20"
                            viewBox="0 0 40 40"
                            style=" fill:#000000; margin:3px;"
                          >
                            <path
                              fill="#98ccfd"
                              d="M20,38.5C9.799,38.5,1.5,30.201,1.5,20S9.799,1.5,20,1.5S38.5,9.799,38.5,20S30.201,38.5,20,38.5z"
                            />
                            <path
                              fill="#4788c7"
                              d="M20,2c9.925,0,18,8.075,18,18s-8.075,18-18,18S2,29.925,2,20S10.075,2,20,2 M20,1 C9.507,1,1,9.507,1,20s8.507,19,19,19s19-8.507,19-19S30.493,1,20,1L20,1z"
                            />
                            <path fill="#fff" d="M20 10A2 2 0 1 0 20 14A2 2 0 1 0 20 10Z" />
                            <g>
                              <path
                                fill="#fff"
                                d="M22 29L22 17 17 17 17 18 18 18 18 29 17 29 17 30 23 30 23 29z"
                              />
                            </g>
                          </svg>
                        </td>
                        <td style="border:none !important; padding-left:0px !important;">{{ this.selectedQuestion.description }}</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <b-field v-show="!isActionFormOpen">
              <b-input
                v-model="selectedQuestion.answerDescription"
                type="textarea"
                rows="3"
                :placeholder="$t('description.processQuestionDescriptionPlaceholder')"
                expanded>
              </b-input>
            </b-field>

            <photo-upload
              ref="photoUpload"
              :class="{ 'is-below-question': isActionFormOpen }"
              v-model="selectedQuestion.photos"
              :question-id="selectedQuestion.id"
              :answer-set-id="answerSetId"
              @deleted="onPhotoDeleted"
            />

            <action-tracking-form
            ref="actionTrackingForm"
              v-model="selectedQuestion"
              :is-open.sync="isActionFormOpen"
            />

            <div :class="{'mt-1': isActionFormOpen}">
              <b-field :class="'is-grouped is-grouped-centered'">
                <b-button
                  size="is-medium is-danger"
                  icon-left="times"
                  :outlined="isNoOutline"
                  @click="saveAnswer(false)">
                  {{ $t('button.no') }}
                </b-button>

                <b-button
                  size="is-medium is-success"
                  icon-left="check"
                  :outlined="isYesOutline"
                  style="margin-left:10px"
                  @click="saveAnswer(true)">
                  {{ $t('button.yes') }}
                </b-button>
              </b-field>
            </div>
          </div>
        </div>

        <div class="b-portlet-footer">
          <b-pagination
            :total="questionCount"
            :current.sync="selectedQuestion.no"
            :range-before="3"
            :range-after="1"
            :order="'is-centered'"
            :simple="false"
            :rounded="true"
            :per-page="1"
            :icon-prev="'arrow-left'"
            :icon-next="'arrow-right'"
            aria-next-label="Sonraki soru"
            aria-previous-label="Önceki soru"
            aria-page-label="Soru"
            aria-current-label="Şu andaki soru"
            @change="changeQuestion"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import helpers from '../../_helpers/vue.helper'
import ApiService from '../../_api/api.service'
import ActionTrackingForm from './ActionTrackingForm.vue'
import PhotoUpload from './PhotoUpload.vue'

export default {
  props: ['process'],
  components: {
    ActionTrackingForm,
    PhotoUpload
  },
  data () {
    return {
      questions: [],
      selectedQuestion: null,
      questionCount: null,
      answerSetId: null,
      allQuestionAnsweredBoxShow: false,
      isNoOutline: true,
      isYesOutline: true,
      actionTitle: '',
      assignedPerson: '',
      dueDate: null,
      isActionFormOpen: false
    }
  },
  computed: {
    ...mapGetters(['role'])
  },
  mounted () {
    this.getAnswerSet()
  },
  methods: {
    changeQuestion (no) {
      if (no > this.questionCount) return
      // Reloading the question on screen would drop its unsaved description and photos
      if (this.selectedQuestion && this.selectedQuestion.id === this.questions[no - 1].id) return
      this.selectedQuestion = { ...this.questions[no - 1] }
      this.changeButtonsOutline(this.selectedQuestion.answer)
    },
    changeButtonsOutline (answer) {
      if (answer === true) {
        this.isYesOutline = false
        this.isNoOutline = true
      } else if (this.selectedQuestion.answer === false) {
        this.isYesOutline = true
        this.isNoOutline = false
      } else {
        this.isYesOutline = true
        this.isNoOutline = true
      }
    },
    saveAndContinueLater () {
      this.$buefy.dialog.alert(this.$t('description.saveAndContinueLaterDialog'))
    },
    finish () {
      const notAnsweredQuestions = this.questions.filter(q => q.answer == null)
      if (notAnsweredQuestions.length > 0) {
        const notAnsweredQuestionNumbers = notAnsweredQuestions.map(q => q.no)
        const notAnsweredQuestionNumbersText = notAnsweredQuestionNumbers.join(',')
        this.$buefy.dialog.alert(
          `${this.$t('description.notAnsweredQuestionsAlert')}<br><br> ${this.$t(
            'title.notAnsweredQuestions'
          )}: ${notAnsweredQuestionNumbersText}`
        )
        this.changeQuestion(notAnsweredQuestionNumbers[0])
      } else {
        ApiService.put('/answerset/close', {
          answerSetId: this.answerSetId,
          processId: this.process.id,
          website: this.$t('title.websiteName'),
          sendEmail: true
        }).then(data => {
          this.score = data
          this.setScore(data)
          this.$emit('next')
          this.$buefy.dialog.alert({
            message: this.$t('description.processFinished'),
            confirmText: this.$t('button.ok')
          })
        })
      }
    },
    // getScores() {
    //   ApiService.get(
    //     `/answerset/${this.answerSetId}/score/?website=${this.$t(
    //       'title.websiteName',
    //     )}&sendEmail=true`,
    //   ).then((data) => {
    //     this.score = data;
    //     this.setScore(data);
    //     this.$emit('next');
    //   });
    // },
    setScore (score) {
      this.$emit('setScore', score)
    },
    skip () {
      this.$emit('skip', 0)
    },
    getAnswerSet () {
      ApiService.get(`/answerset/current/${this.process.id}`)
        .then(data => {
          if (data == null) {
            if (this.role.limited) {
              helpers.showLimitedUserAlert(this, {
                onCancel: () => {
                  this.skip()
                }
              })
            } else {
              this.$buefy.dialog.confirm({
                message: this.$t('description.processLockedAlert'),
                confirmText: this.$t('button.ok'),
                canCancel: false,
                onConfirm: () => this.$emit('skip', 0)
              })
            }
          }
          this.answerSetId = data.id
          this.getQuestions(data.answers)
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error)
          this.$emit('skip', 1)
        })
    },
    getQuestions (answers) {
      ApiService.query(`/process/${this.process.id}/question`).then(data => {
        this.questions = data
        this.questionCount = data.length
        let activeQuestion = 0
        if (answers) {
          answers.forEach(a => {
            this.questions.forEach(q => {
              if (q.id === a.questionId) {
                q.answer = a.answer
                q.answerDescription = a.description
                q.actionTitle = a.actionTitle
                q.actionAssignors = a.actionAssignors
                q.actionDeliveryDate = a.actionDeliveryDate ? new Date(a.actionDeliveryDate) : null
                q.photos = Array.isArray(a.photos) ? a.photos : []
                if (activeQuestion < q.no - 1) {
                  activeQuestion = q.no - 1
                }
              }
            })
          })
        }
        // A copy, like changeQuestion, so unsaved edits never reach the saved answers
        this.selectedQuestion = { ...this.questions[activeQuestion] }
      })
    },
    async saveAnswer (answer) {
      if (!this.$refs.photoUpload.canSave()) return
      this.changeButtonsOutline(answer)
      const { focusButton, actionTrackingForm } = this.$refs
      focusButton.focus()

      var actionTrackingFormIsValid = !actionTrackingForm.hasAction() || await actionTrackingForm.submit()

      if (!actionTrackingFormIsValid) {
        return
      }

      // The form above may have replaced selectedQuestion, and the user may change the
      // question before the request ends, so the saved answer is the one taken here
      const question = this.selectedQuestion
      const photos = question.photos || []
      const request = ApiService.post('/answer', {
        answer,
        questionId: question.id,
        answerSetId: this.answerSetId,
        processId: this.process.id,
        description: question.answerDescription,
        actionTitle: question.actionTitle,
        actionAssignors: question.actionAssignors,
        actionDeliveryDate: question.actionDeliveryDate,
        photos
      })
      this.$refs.photoUpload.trackSave(request, photos)
      request
        .then(() => {
          const savedQuestion = this.questions[question.no - 1]
          savedQuestion.answer = answer
          savedQuestion.answerDescription = question.answerDescription
          savedQuestion.actionTitle = question.actionTitle
          savedQuestion.actionAssignors = question.actionAssignors
          savedQuestion.actionDeliveryDate = question.actionDeliveryDate
          savedQuestion.photos = photos
          const nextQuestionNo = this.selectedQuestion.no + 1

          if (this.questions.length >= nextQuestionNo) {
            this.changeQuestion(nextQuestionNo)
          }

          if (!this.allQuestionAnsweredBoxShow) {
            const notAnsweredQuestions = this.questions.filter(q => q.answer == null)
            if (notAnsweredQuestions.length < 1) {
              this.$buefy.dialog.confirm({
                message: this.$t('description.allQuestionsAnswered'),
                confirmText: this.$t('button.calculateScore'),
                cancelText: this.$t('button.turnBack'),
                canCancel: true,
                onConfirm: () => this.finish()
              })
              this.allQuestionAnsweredBoxShow = true
            }
          }
        })
        .catch(() => {
          this.questions[question.no - 1].answer = null
        })
    },
    onPhotoDeleted ({ url, questionId }) {
      const savedQuestion = this.questions.find(q => q.id === questionId)
      if (savedQuestion && savedQuestion.photos) {
        savedQuestion.photos = savedQuestion.photos.filter(photo => photo !== url)
      }
    }
  }
}
</script>
<style scoped>
/* With the action form open the photos come right after the question box, so the space below
   them matches the box's */
.photo-upload.is-below-question {
  margin-bottom: 1.5rem;
}

.description-content{
  padding: 10px;
  border-radius: 5px;
  margin-top: 10px;
  font-style: italic;
}
</style>
